// Texty stránky výsledků vyhledávání (searchPage.js).
export default {
  more: 'Načíst další',
  // „Načíst “ + „další “/„dalších “ + countLabel(n, 'products') — sklad slov
  // pro `moreLabel()`, singulárně/plurálně dle hranice 5.
  morePrefix: 'Načíst ',
  moreFew: 'další ',
  moreMany: 'dalších ',
  // Řada „Podobné skladem" (#284)
  similar: 'Podobné skladem',
  similarSubCat: 'Skladem z kategorie ',
  similarSub: 'Skladem ze stejných kategorií',
  similarPrev: 'Předchozí produkty',
  similarNext: 'Další produkty',
  // Řazení jako jeden ovladač „Řadit: Shoda" (mobil a tablet, mock 2026-10-14)
  sortPrefix: 'Řadit: ',
  sortAria: 'Řazení výsledků',
  // Popisky voleb řazení (`SORTS`)
  sortLabels: {
    relevance: 'Shoda',
    bestseller: 'Nejprodávanější',
    price_asc: 'Nejlevnější',
    price_desc: 'Nejdražší',
    newest: 'Novinky',
  },
  /** nadpis nad vlastní mřížkou místo nativní hlášky „Produkty nebyly nalezeny" */
  productsHeading: 'Produkty',
};
